import { TDownloadListFile } from '@/types/downloadList'
import { isAssetWithRawElement } from '@/utils/type_predicates'

export const getFilenameFromFileObj = (file: TDownloadListFile) => {
	if (isAssetWithRawElement(file))
		return (file.title || file.fileName || '').trim()
	return (file.elements.title.value || '').trim()
}
